<template>
  <el-dialog
    v-model="visible"
    title="🚀 VideoInsight 新手快速上手指南"
    width="680px"
    center
    destroy-on-close
    class="quick-guide-modal"
  >
    <div class="guide-steps">
      <el-steps :active="activeStep" finish-status="success" align-center style="margin-bottom: 24px;">
        <el-step title="第一步" description="探索灵感与搜索爆款" />
        <el-step title="第二步" description="无水印解析与内容提取" />
        <el-step title="第三步" description="AI 编导与智能视频创作" />
      </el-steps>

      <div class="step-card">
        <div v-if="activeStep === 0" class="step-content">
          <div class="step-icon">🔍</div>
          <h4>1. 搜索热门短视频与爆款趋势</h4>
          <p>进入「采集与搜索 / 灵感广场」，输入任意关键词（如“AI变现”、“美食剧场”），即刻实时检索 20+ 主流短视频平台的热门视频、评论与核心数据。</p>
          <el-tag type="info">Tip: 点击热词卡片可一键检索</el-tag>
        </div>

        <div v-else-if="activeStep === 1" class="step-content">
          <div class="step-icon">🎬</div>
          <h4>2. 多平台 URL 智能解析与去水印提取</h4>
          <p>粘贴 B站/抖音/YouTube/小红书等视频链接，系统自动抓取 4K/1080P 无水印画质视频，并支持一键智能去除背景字幕与水印。</p>
          <el-tag type="info">Tip: 可以在任务队列中查看后台渲染进度</el-tag>
        </div>

        <div v-else-if="activeStep === 2" class="step-content">
          <div class="step-icon">🤖</div>
          <h4>3. AI 编导辅助生成剧本与视频重构</h4>
          <p>基于提取的字幕文本与画面帧，利用大模型（GPT-4/Claude/DeepSeek）自动改写爆款文案、生成分镜故事板并快速生成二创视频。</p>
          <el-tag type="success">准备好了？开启你的爆款内容创作之旅！</el-tag>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="modal-footer-btns">
        <el-button v-if="activeStep > 0" @click="activeStep--">上一步</el-button>
        <el-button v-if="activeStep < 2" type="primary" @click="activeStep++">下一步</el-button>
        <el-button v-else type="success" round @click="finishGuide">开始体验项目</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const visible = ref(false)
const activeStep = ref(0)

const open = () => {
  activeStep.value = 0
  visible.value = true
}

const finishGuide = () => {
  visible.value = false
  router.push('/search')
}

defineExpose({
  open
})
</script>

<style scoped>
.guide-steps {
  padding: 8px 12px;
}
.step-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.step-icon {
  font-size: 40px;
  margin-bottom: 12px;
}
.step-content h4 {
  font-size: 16px;
  color: #2c3e50;
  margin-bottom: 8px;
}
.step-content p {
  font-size: 14px;
  color: #606266;
  margin-bottom: 12px;
  line-height: 1.5;
}
.modal-footer-btns {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
